const Config = {

  socials: {
    instagram: {
      url: "https://instagram.com/Mindalitix?igshid=NTc4MTIwNjQ2YQ==",
      name: "Mindalitix",
    },
    facebook: {
      url: "https://www.facebook.com/profile.php?id=61552011542263",
      name: "Mindalitix",
    },
    twitter: {
      url: "https://x.com/Mindalitix?s=20", 
      name: "Mindalitix",
    },
    linkedIn: {
      url: "",
      name: "Mindalitix",
    },
    telegram:{
      url:"https://t.me/Mindalitix",
    }
  },
  paystackPublicKey: import.meta.env.VITE_PAYSTACK_PUBLIC_KEY as string,
  /**
   * The payment methods offered at checkout, and named on the course page.
   *
   * Declared rather than left to Paystack's default for one reason: the sales
   * page tells a buyer which methods they can use, and the only way that
   * sentence can be guaranteed true is if the same list is what the widget is
   * opened with. Left to the default, the page would be describing whatever the
   * Paystack dashboard happens to have switched on today.
   *
   * Values are Paystack channel names. The default is the three methods that
   * matter in Nigeria; set VITE_PAYSTACK_CHANNELS to narrow or widen it, and
   * the page copy follows automatically.
   *
   * A channel listed here that the merchant account has *not* enabled simply
   * does not appear in the widget — Paystack intersects the two — so the
   * failure mode is a method going unmentioned, never one being promised and
   * missing.
   */
  // Transfer leads because Nigeria pays by transfer: 66% of Paystack's
  // Nigerian transactions in 2024 against 26% by card, and the order here is
  // the order the widget shows. Asking a stranger from an advert for card
  // details first is asking the wrong question.
  paystackChannels: ((import.meta.env.VITE_PAYSTACK_CHANNELS as string) || 'bank_transfer,card,ussd')
    .split(',')
    .map((channel) => channel.trim())
    .filter(Boolean),
  // Reads the environment like every other setting. This was hardcoded, which
  // made VITE_GOOGLE_CLIENT_ID in .env dead config — editing it changed nothing,
  // and the id was duplicated into Auth.tsx's markup as a third copy. An OAuth
  // client id is public by design, so the literal stays as a fallback.
  googleClientId:
    (import.meta.env.VITE_GOOGLE_CLIENT_ID as string) ||
    "793790360566-atc27gbipf2so01lnp5423snqa8d5gga.apps.googleusercontent.com",
};

export default Config;
